const EmptyArticleList = () => {
    return (
        <span className="text-base text-on-surface/60 font-normal">
            Nie masz jeszcze zadnych artykułów
        </span>
    )
}

export default EmptyArticleList
